const NUMBERS_SCALE = {
  LOW_LIMIT: 33,
  HIGH_LIMIT: 67,
};

export default angular
  .module('sfMobile.constants.numbers-scale', [])
  .constant('SF_NUMBERS_SCALE', NUMBERS_SCALE).name;
